import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RsbService } from 'src/app/service/rsb.service';
import { RsbLookupModel } from 'src/app/common/model/rsb-lookup.model';
import { ViewLeadPopupComponent } from '../../view-lead-popup/view-lead-popup.component';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { statuses } from 'src/app/common/events/status.service';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { NotificationService } from 'src/app/common/events/notificationservice';
@Component({
  selector: 'app-pending-followup',
  templateUrl: './pending-followup.component.html',
  styleUrls: ['./pending-followup.component.css']
})
export class PendingFollowupComponent implements OnInit {
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  filters = {
    type: '',
    search: '',
    staffName: '0',
    status: '0',
    category: '0'
  };
  pageSize = 10;
  todayFollowup: number = 0;
  pendingFollowup: number = 0;
  completeFollowup: number = 0;
  pageIndex = 0;
  totalRecords = 0;
  staffName: string = '0'
  type: any;
  mainModules: any;
  counts: any = {}
  paginatedRecords = [];
  allStaffRecords: any;
  allStaffRecordsList: any;
  childData: any;
  statusList: any = statuses
  serviceType: string = '';
  statusType: string = 'pending';
  selectedStatusType: String = '';
  expandedRow: number | null = null;
  expandedIndex: number | null = null;
  editRowValues: { [rowIndex: number]: { status: string, remarks: string } } = {};
  editIndex: number | null = null;
  saveAttempted = false;
  constructor(private modalService: NgbModal,
    private rsbService: RsbService,
    public rsbLookup: RsbLookupModel,
    private router: Router,
    private toast: ToastrService,
    private notify: NotificationService
    //public lookupModel: RsbLookupModel
  ) { }

  ngOnInit(): void {
    this.statusType = this.rsbLookup.getSelectedStatusType() ? this.rsbLookup.getSelectedStatusType() : 'pending';
    this.selectedStatusType = this.statusType;
    this.type = this.rsbLookup.getLoggedUser().type ? this.rsbLookup.getLoggedUser().type : 'subFranchise';
    this.getStaffList();
    this.getStaff('pending');
    this.getFollowupCount(this.type)
    this.getAllMainModules()

  }

  getFollowupCount(type: string, id?: string, ui?: boolean): void {
    this.rsbService.getFollowupCount({ franchiseId: id ? id : this.rsbLookup.getLoggedUser().franchiseId }, this.filters).subscribe((rsp) => {
      if (rsp.statusCode === 0) {
        this.todayFollowup = rsp.contents.todayFollowups
        this.pendingFollowup = rsp.contents.pendingFollowups
        this.completeFollowup = rsp.contents.completeFollowup
      }
    })
  }

  getAllMainModules(): void {
    this.rsbService.getAllMainModules({}).subscribe((rsp) => {
      if (rsp.statusCode === 0) {
        this.mainModules = rsp.contents
      }
    })
  }



  clearSearch() {
    this.filters.search = '';
    this.applyFilters()
  }

  applyFilters(): void {
    this.getStaff(this.statusType)
  }

  resetFilters() {
    this.filters = {
      type: '',
      search: '',
      staffName: '',
      status: '0',
      category: '0'
    };
    this.applyFilters()
  }

  redirectUrl(data: any): void {
    let url = '';
    switch (data.moduleName.toUpperCase()) {
      case 'RENT':
      case 'BUY':
        url =
          'https://pillarblocks.com/property-details/' +
          encodeURIComponent(data.propertyTitle.replaceAll(' ', '-')) +
          '?listingId=' + data.propertyId +
          '&cat=' + data.categoryId +
          '&subcat=' + data.subCategoryId +
          '&module=' + data.moduleId +
          '&country=hCDjcS' +
          '&city=' + encodeURIComponent(data.city) +
          '&area=' + encodeURIComponent(data.area) +
          '&pincode=' + data.pincode;
        break;

      case 'PROJECTS':
        url =
          'https://pillarblocks.com/project-description/' +
          encodeURIComponent(data.projectName) +
          '?projectId=' + data.projectId +
          '&cat=' + data.categoryId +
          '&subcat=' + data.subCategoryId +
          '&country=hCDjcS' +
          '&city=' + encodeURIComponent(data.city) +
          '&area=' + encodeURIComponent(data.area) +
          '&pincode=' + data.pincode;
        break;
      case 'Plot & Land':
        url = 'https://pillarblocks.com/'
      case 'PG / HOSTELS':
      // url = 'https://pillarblocks.com/'
      case 'COMMERCIAL':
        // TODO: Build URLs for these modules if needed
        break;
    }
    if (url) {
      window.open(url, '_blank'); // open in new tab
    }
  }

  selectStaff(event: any) {
    if (event.target.value !== '0') {
      this.filters.type = this.rsbLookup.getLoggedUser().type === 'franchise' ? 'staff' : 'substaff'
    } else {
      this.filters.type = ''
    }
  }
  getStaffList(): void {
    this.rsbService.getStaffDataWithoutPagination().subscribe((rsp) => {
      if (rsp.statusCode === 0) {
        this.allStaffRecordsList = rsp.contents
      }
    })
  }

  closeEdit(index: number) {
    this.editIndex = null
    this.saveAttempted = false;
    delete this.editRowValues[index];
  }

  startEditingRow(index: number) {
    this.editIndex = index;
    this.saveAttempted = false;
    this.editRowValues[index] = { status: '0', remarks: '' }; // default status = "0"
  }
  selectService(type: string) {
    this.selectedStatusType = type;
    this.statusType = type;
    this.rsbLookup.setSelectedStatusType(type);
    this.getStaff(type);
  }
  getStaff(type: string, id?: string, ui?: boolean): void {
    if (ui) {
      this.filters = {
        type: '',
        search: '',
        staffName: '0',
        status: '0',
        category: '0'
      };
    }
    this.statusType = type;
    if (type === 'pending') {
      this.rsbService.getPendingFollowup({ franchiseId: id ? id : this.rsbLookup.getLoggedUser().franchiseId }, this.filters, this.pageSize, this.pageIndex).subscribe((rsp) => {
        if (rsp.statusCode === 0 && rsp.contents.items?.length) {
          this.allStaffRecords = rsp.contents.items
          this.totalRecords = rsp.contents.total
          
        } else {
          this.allStaffRecords = []
        }
        this.updatePaginatedRecords()
        this.getFollowupCount(this.type)
      })
    } else if (type === 'today') {
      this.rsbService.getTodayFollowup({ franchiseId: id ? id : this.rsbLookup.getLoggedUser().franchiseId }, this.filters, this.pageSize, this.pageIndex).subscribe((rsp) => {
        if (rsp.statusCode === 0 && rsp.contents.items?.length) {
          this.allStaffRecords = rsp.contents.items
          this.totalRecords = rsp.contents.total
        } else {
          this.allStaffRecords = []
        }
        this.updatePaginatedRecords()
        this.getFollowupCount(this.type)
      })
    } else if (type === 'complete') {
      this.rsbService.getCompleteFollowup({ franchiseId: id ? id : this.rsbLookup.getLoggedUser().franchiseId }, this.filters, this.pageSize, this.pageIndex).subscribe((rsp) => {
        if (rsp.statusCode === 0 && rsp.contents.items?.length) {
          this.allStaffRecords = rsp.contents.items
          this.totalRecords = rsp.contents.total
        } else {
          this.allStaffRecords = []
        }
        this.updatePaginatedRecords()
        this.getFollowupCount(this.type)
      })
    } else {
      alert('Something went wrong');
    }
  }

  updatePaginatedRecords() {
    this.paginatedRecords = this.allStaffRecords;
  }
  addStaff(): void {
  }

  getStatusName(value: number): string {
    const status = this.statusList.find(s => s.value === value);
    return status ? status.name : '';
  }

  getStatusClass(status: string): string {
    switch (status) {
      case 'Verified Lead':
        return 'status-verified';
      case 'Qualified Lead':
        return 'status-qualified';
      default:
        return 'status-default';
    }
  }

  getLeadTypeClass(type: string): string {
    switch (type) {
      case 'Online':
      case 'online':
        return 'lead-online';
      case 'Walkin':
        return 'lead-walkin';
      case 'Referral':
        return 'lead-referral';
      default:
        return 'lead-default';
    }
  }

  getCategoryClass(category: string): string {
    switch (category) {
      case 'Sale':
        return 'category-sale';
      case 'Rent':
        return 'category-rent';
      case 'Loans':
      case 'loans':
        return 'cat-loan';
      case 'Housing':
        return 'category-housing';
      case 'creditCard':
        return 'cat-credit-card'
      default:
        return 'category-default';
    }
  }


  view(leads: any, status, remarks): void {
    this.serviceType = leads.propType
    const modalRef = this.modalService.open(ViewLeadPopupComponent, {
      backdrop: 'static',
      keyboard: false
    });
    modalRef.componentInstance.leadStatus = status
    modalRef.componentInstance.statusSelected = status
    modalRef.componentInstance.remarks = remarks
    modalRef.result.then((result) => {
      let payload = {}
      result.status = Number(result.status);
      if (result.status === 5) {
        payload = {
          id: this.rsbLookup.getLoggedUser().franchiseId,
          status: result.status,
          leadId: leads.leadId,
          date: result.date,
          description: result.remarks,
          propType: this.serviceType
        }
        this.rsbService.addFollowup(payload).subscribe((rsp) => {
          if (rsp.statusCode === 0) {
            this.followupRedirectedMethod(result)
          }
        })


      } else if (Number(result.status === 9)) {
        payload = {
          franchiseId: this.rsbLookup.getLoggedUser().franchiseId,
          status: result.status,
          opportunityStatus: result.opportunityStatus,
          leadId: leads.leadId,
          remarks: result.remarks,
          description: result.remarks,
          propType: this.serviceType,
          date: result.date
        }
        this.rsbService.addOppFranchiseLogs(payload).subscribe((rsp) => {
          if (rsp.statusCode === 0) {
            this.toast.success('Lead Successfully updated to Followup');
            this.notify.getCalendarData();
            this.router.navigate(['organizedLeads'])
          }
        })
      } else {
        payload = {
          leadId: leads.leadId,
          status: result.status,
          description: result.remarks,
          remarks: result.remarks
        }
      }
      if (this.serviceType === 'realEstate') {
        this.rsbService.updateLeadStatusForRealEstate(payload).subscribe((rsp) => {
          if (rsp.statusCode === 0) {
            this.redirectMethod(result)
          }
        })

      } else if (this.serviceType === 'finTech') {
        this.rsbService.updateLeadStatusForFintech(payload).subscribe((rsp) => {
          if (rsp.statusCode === 0) {
            this.redirectMethod(result)
          }
        })

      } else if (this.serviceType === 'propServices') {
        this.rsbService.updateLeadStatusForPropServices(payload).subscribe((rsp) => {
          if (rsp.statusCode === 0) {
            this.redirectMethod(result)
          }
        })

      }

    })

  }


  redirectMethod(result: any): void {
    this.notify.getCalendarData()
    if (result.status != 9 || result.status !== 5) {
      this.router.navigate(['Leads']);
    } else if (result.status == "9") {
      this.router.navigate(['organizedLeads']);
    }
  }

  generateTitle(leadRec) {
    switch (leadRec.product) {
      case 'Villa':
      case 'Apartment':
      case 'Independent House':
      case 'Flat': {
        const att = this.checkAttributes(leadRec.attributes || []); // assuming this is a method that processes Attr
        if (att) {
          return `${att} ${leadRec.product}`;
        } else {
          return leadRec.product
        }
      }
      case 'Plot':
      case 'Land': {
        const size = leadRec.measurementName ? `${leadRec.measurementName} ` : '';
        return `${leadRec.propertySize} ${size} ${leadRec.product}`;
      }
      default:
        return leadRec.product || 'Unknown Property';
    }
  }

  checkAttributes(attributes: []): string {
    let attributesRes: any = {}
    if (attributes.length) {
      attributesRes = attributes.find((obj: any) => {
        return obj.attributeName.toUpperCase() === "BHK"
      })
    }
    let res = ''
    if (Object.values(attributesRes).length > 0) {
      res = attributesRes?.attributePropertyName + ' ' + 'BHK';
    }
    return res;
  }

  getProductClass(product: string): string {
    switch (product) {
      case 'Villa':
        return 'product-villa';
      case 'Apartment':
        return 'product-apartment';
      case 'Independent House':
        return 'product-apartment';
      case 'Land':
        return 'product-land';
      case 'Flat':
        return 'product-flat';
      case 'Plot':
        return 'product-plot';
      case 'Housing':
        return 'product-housing'; // Add this line
      case 'eduloan':
      case 'Edu Loan':
        return 'product-edu-loan'; // Add this line
      case 'Home Loan':
        return 'home-loan';
      case 'LAP':
        return 'laploan'; // Add this line
      case 'Personal/Self':
        return 'personalloan'; // Add this line
      case 'CCTV':
        return 'cctv'; // Add this line
      case 'Interior':
        return 'interior'; // Add this line
      case 'Furniture':
        return 'furniture'; // Add this line
      case 'Packers And Movers':
        return 'packers'; // Add this line

      default:
        return 'product-default';
    }
  }

  saveRemark(lead: any, index: number) {
    const rowValues = this.editRowValues[index];
    const remarks = rowValues.remarks.trim();
    const status = Number(rowValues.status);
    if (status === 0 || remarks.length < 5) {
      this.saveAttempted = true;
      this.toast.warning('Select a status and enter at least 5 characters for remarks.');
      return;
    }

    this.saveAttempted = false;
    if (status === 5 || status === 9) {
      this.view(lead, status, remarks)
    } else {
      this.rsbService.addFranchiseLogs({ status: rowValues.status, leadId: lead.leadId, franchiseId: lead.franchiseId, remarks }).subscribe((rsp) => {
        if (rsp.statusCode === 0) {
          this.redirectMethod({ status: rowValues.status })
        }
      })

      this.editIndex = null; // Exit edit mode
    }
  }


  followupRedirectedMethod(result: any): void {
    this.notify.getCalendarData();
    const inputDate = new Date(result.date);
    const today = new Date();

    // Normalize both dates to remove time components for accurate comparison
    inputDate.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);

    if (inputDate > today) {
      this.router.navigate(['./FollowUp']); // Date is in the future
    } else if (inputDate < today) {
      this.router.navigate(['./FollowUp']); // Date is in the past
    } else {
      this.router.navigate(['./FollowUp']); // Date is today
    }
  }

  toggleRow(index: number) {
    const leadId = this.allStaffRecords[index].leadId;
    this.rsbService.getFollowupDetailsOfLead(leadId).subscribe((rsp) => {
      if (rsp.statusCode === 0) {
        this.childData = rsp.contents
        this.expandedIndex = this.expandedIndex === index ? null : index;
      }
    })

  }

  onPageChange(event: PageEvent) {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.getStaff(this.statusType, this.serviceType)
  }

}


